import { render, staticRenderFns } from "./ArticleElement.vue?vue&type=template&id=ae3262e6&scoped=true&"
import script from "./ArticleElement.vue?vue&type=script&lang=js&"
export * from "./ArticleElement.vue?vue&type=script&lang=js&"
import style0 from "./ArticleElement.vue?vue&type=style&index=0&id=ae3262e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3262e6",
  null
  
)

export default component.exports